import { FC } from 'react';
import { ContentLoader } from '@edikk-edikk/country-common';
import { MetaData } from '@edikk-edikk/country-frontend';
import { useProcessApiError } from '@edikk-edikk/hooks';
import { useApi } from '#hooks/use-api';
import { Breadcrumbs, Info } from '#advertDetail/components';
import { AdvertDetailContext, AdvertDetailContextType } from '#advertDetail/contexts';
import { Container } from '#components/container';

type PropsType = {
  id: number;
};

const AdvertDetail: FC<PropsType> = ({
  id,
}) => {
  const api = useApi();
  const {
    data,
    error,
    isFetching,
    isError,
  } = api.getApiAdvertDetail().useInitQuery(id);
  useProcessApiError(error);

  if (isFetching) {
    return <ContentLoader />;
  }

  if (isError) {
    return null;
  }

  const advertDetailContextValue: AdvertDetailContextType = {
    advert: data.advert,
    seo: data.seo,
  };

  return (
    <AdvertDetailContext value={advertDetailContextValue}>
      <MetaData seo={data.seo} />
      <Breadcrumbs />
      <Container withMarginTop withMarginBottom dataAttributeList={{ id: data.advert.id }}>
        <Info />
      </Container>
    </AdvertDetailContext>
  );
};

export { AdvertDetail };
